import { createFileRoute } from '@tanstack/react-router';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { SeoTags } from '#src/components/SeoTags/index.ts';
import { coursePageSearchValidator, CoursesPage } from '#src/pages/CoursesPage/index.ts';

export const Route = createFileRoute('/{-$locale}/courses')({
  component: RouteComponent,
  validateSearch: coursePageSearchValidator
});

function RouteComponent() {
  const navigate = Route.useNavigate();
  const searchParams = Route.useSearch();

  const intl = useIntl();

  return (
    <>
      <SeoTags
        title={intl.formatMessage({
          id: 'head.classes-page',
          defaultMessage: 'Classes in Hong Kong'
        })}
      />

      <CoursesPage
        onUpdateSearchParams={useCallback(search => navigate({ search }), [navigate])}
        searchParams={searchParams}
      />
    </>
  );
}
